import { AlertCircle } from 'lucide-react'
import { cn } from '@/utils/helpers'
import { PERMISSIONS_HELP_URL } from '@/constants/meeting'

type PermissionWarningCardProps = {
  className?: string
}

export const PermissionWarningCard = ({ className }: PermissionWarningCardProps) => {
  const handleHelpClick = () => {
    window.open(PERMISSIONS_HELP_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <div
      className={cn(
        'flex items-center gap-4 md:rounded-lg px-4 py-3',
        'bg-red-100',
        className
      )}
      role="alert"
    >
      {/* Icon */}
      <div className="flex shrink-0 items-center justify-center">
        <div className="flex h-8 w-8 items-center justify-center">
          <AlertCircle className="size-6" aria-hidden="true" />
        </div>
      </div>

      {/* Message */}
      <div className="flex-1 text-sm">
        <p>
          Vous devez autoriser votre navigateur à accéder à votre caméra et votre micro. Pour cela,
          recherchez l&apos;icone de la caméra ou du micro dans la barre de votre navigateur et
          cliquez dessus.
        </p>
      </div>

      {/* Help Link */}
      <div className="shrink-0">
        <button
          onClick={handleHelpClick}
          className="text-sm font-medium underline focus:outline-none rounded"
        >
          J&apos;ai besoin d&apos;aide
        </button>
      </div>
    </div>
  )
}
